'use client';

import { LazyMount } from './LazyMount';

// Каждый load — отдельная точка код-сплиттинга внутри клиентского модуля,
// поэтому чанк секции реально не запрашивается до visible=true (см.
// комментарий в LazyMount.tsx о том, почему children из page.tsx не подходят).

export function LazyNumbersPanel() {
  return <LazyMount load={() => import('@/components/sections/NumbersPanel').then((m) => ({ default: m.NumbersPanel }))} />;
}

export function LazyCases() {
  return <LazyMount load={() => import('@/components/sections/Cases').then((m) => ({ default: m.Cases }))} />;
}

export function LazyProcess() {
  return <LazyMount anchorId="process" load={() => import('@/components/sections/Process').then((m) => ({ default: m.Process }))} />;
}

export function LazyFAQ() {
  return <LazyMount anchorId="faq" load={() => import('@/components/sections/FAQ').then((m) => ({ default: m.FAQ }))} />;
}

export function LazyLeadForm() {
  return <LazyMount anchorId="lead" load={() => import('@/components/sections/LeadForm').then((m) => ({ default: m.LeadForm }))} />;
}

export function LazyFooter() {
  return <LazyMount load={() => import('@/components/sections/Footer').then((m) => ({ default: m.Footer }))} />;
}
